import React from 'react';
import { intersperse } from 'ramda';

export type InterposeProps = {
  /**
   * A component used as a separator
   */
  separator: React.ReactNode;
  /**
   * An array of components
   */
  children: React.ReactNode[];
};

/**
 * This component can be used to separate a list of components
 * with some other component between them.
 */
export const Interpose: React.FC<InterposeProps> = ({ separator, children }): any => {
  const arr = intersperse(separator, React.Children.toArray(children));

  return arr.map((child, key) => React.cloneElement(child as React.ReactElement, { key }));
};
